import { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { initNativeApp } from "./lib/capacitorNative";

const AppRouter = lazy(() => import("./AppRouter"));

const AppLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-background text-foreground">
    <span className="text-sm font-bold">Loading...</span>
  </div>
);

export const bootstrapNonLanding = (rootElement: HTMLElement) => {
  initNativeApp();
  createRoot(rootElement).render(
    <AppErrorBoundary>
      <Suspense fallback={<AppLoading />}>
        <AppRouter />
      </Suspense>
    </AppErrorBoundary>,
  );
};
